import React from 'react';
import { Box, Link, Typography } from '@mui/material';

import Disclosure from 'components/Icons/Disclosure';
import { DisclosureDirection, TypographyType } from 'types/mui';
import styles from './DisclosureWithText.module.scss';

interface Props {
  classnames?: {
    disclosureButton?: string;
    typographyText?: string;
  };
  disclosureColor: string;
  onClickHandler?: () => void;
  buttonText: string;
  direction: DisclosureDirection;
  typographyVariant: TypographyType;
  disclosureRotation: number;
  clickableText?: boolean;
  href?: string;
}

const DisclosureWithText: React.FC<Props> = ({
  disclosureRotation,
  classnames,
  disclosureColor,
  onClickHandler,
  buttonText,
  direction,
  typographyVariant,
  clickableText = false,
  href,
}) => (
  <Box
    className={classnames?.disclosureButton || styles.disclosureButton}
    data-testid="disclosure-container"
  >
    {direction === DisclosureDirection.RIGHT && buttonText && (
      <Typography
        variant={typographyVariant}
        className={classnames?.typographyText || styles.typographyText}
        data-testid="disclosure-text"
      >
        {clickableText ? (
          <Link
            data-testid="disclosure-link"
            href={href}
            style={{ textDecoration: 'none' }}
            className={classnames?.typographyText || styles.typographyText}
          >
            {buttonText}
          </Link>
        ) : (
          buttonText
        )}
      </Typography>
    )}
    <Disclosure
      rotation={disclosureRotation}
      color={disclosureColor}
      onClick={onClickHandler}
      dataTestId="disclosure"
    />
    {direction === DisclosureDirection.LEFT && buttonText && (
      <Typography
        variant={typographyVariant}
        className={classnames?.typographyText || styles.typographyText}
        data-testid="disclosure-text"
      >
        {clickableText ? (
          <Link
            data-testid="disclosure-link"
            style={{ textDecoration: 'none' }}
            className={classnames?.typographyText || styles.typographyText}
            href={href}
          >
            {buttonText}
          </Link>
        ) : (
          buttonText
        )}
      </Typography>
    )}
  </Box>
);

export default DisclosureWithText;
